import {
  updateDetailsStaticFetchStatus,
  updateDetailsStaticData,
  updateSearchRoomFetchStatus,
  updateSearchRoomData,
  updateDetailsCartResponseData,
  updateDetailsCartUIData,
  setActivePayModeInCart,
  updateArcReachedForRoomCode,
  updateDetailsCartFetchStatus,
  updateDetailsCartRequestData,
  updateAlternateDatesFetchStatus,
  updateAlternateDatesData,
  setSelectedRatePlanAction,
  updateSlotsFetchStatus,
  updateSlotsData,
  updateAlternateDatesHotelId,
} from '../details/actions';
import {
  fetchStaticDetailsData,
  prepareStaticDetailRequest,
} from '@stencil/hotels-cg-api/src/details-static-api';
import {fetchSearchRoomData} from '@stencil/hotels-cg-api/src/details-search-room-api';
import {
  prepareSlotsDayUseRequestData,
  fetchSlotsDayUseDetailsData,
} from '@stencil/hotels-cg-api/src/day-use-details-slots-api';
import {fetchCartUpdatePriceData} from '@stencil/hotels-cg-api/src/details-cart-update-price';
import {AnyAction} from 'redux';
import {ThunkAction, ThunkDispatch} from 'redux-thunk';
import {AppState} from '../../../../../verticals/hotels-dweb/src/shared/store';
import API_STATE from '../common/apiState';
import {goingForwardPropertyIdSelector} from '@stencil/hotels-common-reducer/src/selectors';
import {fetchAlternateDate} from '@stencil/hotels-cg-api/src/details-alternate-dates';
import {
  getCartRoomSeletionObject,
  getRoomsArrayForCartRooms,
} from '@stencil/hotels-utils/src/common-utils';
import {
  getUrlParams,
  getDayUseDetailsSlotsData,
  getFilterCriteria,
} from '@stencil/hotels-cg-api/src/apiUtils';
import {omnitureThunk, omnitureConfig} from '@stencil/omniture-analytics/src';

const pushOmnitureErrorThunk = ({dispatch, additionalData}) => {
  return dispatch(
    omnitureThunk(
      omnitureConfig.pages.DetailsUnif,
      omnitureConfig.events.pageError,
      additionalData,
    ),
  );
};

const prepareStaticRequest = ({
  uuids = [],
  requestObj = {
    urlParams: {},
    comparatorHotelIds: [],
    requiredApis: {},
    flavour: 'desktop',
  },
  dispatch,
  apiCallCount,
  pokus,
}) => {
  if (apiCallCount > 8) return;
  const staticDetailsRequest = prepareStaticDetailRequest({
    requestObj,
    pokus,
  });
  if (uuids) {
    staticDetailsRequest.uuids = uuids;
  }
  const s = fetchStaticDetailsData({staticDetailsRequest, client: requestObj?.flavour});
  // @ts-ignore
  s.then(resp => {
    if (resp?.data?.response) {
      const {response, response: {uuids} = {} as {uuids: string[]}} = resp?.data;
      if (apiCallCount === 0) {
        response.hotelId = staticDetailsRequest?.searchCriteria?.giHotelId;
      }
      dispatch(updateDetailsStaticData({data: response}));
      apiCallCount += 1;
      // responseSetCallback(resp?.data);
      // apifetchstatusCallback();

      if (uuids && uuids.length > 0) {
        prepareStaticRequest({
          uuids,
          requestObj,
          dispatch,
          apiCallCount,
          pokus,
        });
      }
    } else if (resp?.data?.error) {
      dispatch(updateDetailsStaticFetchStatus({status: API_STATE.ERROR_STATE(resp?.data?.error)}));
    }
  }).catch(err => {
    console.log(err);
    const {status = '', statusText = ''} = err?.response || {};
    dispatch(updateDetailsStaticFetchStatus({status: API_STATE.ERR_STATE}));
    pushOmnitureErrorThunk({
      dispatch,
      additionalData: {error: `${omnitureConfig.APIType.staticDetails}|${status}|${statusText}`},
    });
  });
  return s;
};

export const getAppliedFiltersInUrl = (appliedFiltersInUrl = []) => {
  const appliedFiltersMap = appliedFiltersInUrl?.map(appliedFilterInUrl =>
    appliedFilterInUrl?.filterValues?.map(filterValue => ({
      filterGroup: appliedFilterInUrl?.filterGroup || '',
      filterValue: filterValue,
      filterRange: null,
      isRangeFilter: false,
    })),
  );

  let flatArray = appliedFiltersMap?.reduce((acc, curVal) => {
    return acc.concat(curVal);
  }, []);

  return flatArray?.filter(d => d);
};

export const fetchDetailsStaticDataThunk = (
  flavour = 'desktop',
  hotelId?,
  mmtId = '',
  uuids = [],
  isDayUse?,
): ThunkAction<void, AppState, {}, AnyAction> => {
  // Invoke API
  return (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    const state = getState();
    const {common} = state;
    if (!uuids?.length) {
      dispatch(updateDetailsStaticFetchStatus({status: API_STATE.LOADING_STATE}));
    }

    const selectedHotelId = hotelId || goingForwardPropertyIdSelector(state);
    const urlParams = getUrlParams(common, selectedHotelId, mmtId, isDayUse);

    const requiredApis = isDayUse
      ? {
          reviewSummaryRequired: true,
          shortlistingRequired: true,
          staticData: true,
          walletRequired: true,
          locus: true,
          addOnRequired: true,
          showUpsell: true,
          soldOutInfoReq: true,
          bestCoupon: false,
          applyAbsorption: true,
          dayUsePersuasion: true,
          freeCancellationAvail: true,
          quickReview: true,
          showBnplCard: true,
          coupon: false,
        }
      : {
          reviewSummaryRequired: true,
          luxuryRequired: true,
          persuasionsRequired: true,
          placesRequired: true,
          topReviewsRequired: true,
          detailPersuasionCardsRequired: true,
          weaverResponseRequired: true,
          roomInfoRequired: true,
          comparatorV2Required: true,
        };
    let apiCallCount = 0;
    prepareStaticRequest({
      requestObj: {
        urlParams,
        comparatorHotelIds: [],
        requiredApis,
        flavour,
      },
      uuids,
      dispatch,
      apiCallCount,
      pokus: common?.pokusExpData,
    });
  };
};

export const fetchSearchRoomDataThunk = (
  flavour = 'desktop',
  hotelId = '',
  successCallback = () => {},
  isSeo = false,
  newFilterData = {},
  mmtId = '',
): ThunkAction<void, AppState, {}, AnyAction> => {
  // Invoke API
  return (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    const state = getState();
    const {common, detailsUnif} = state;
    const {checkin, checkout, roomString, isDatePickRequired} = common;
    if (detailsUnif?.searchRoomRequestState?.loading) return;
    const selectedHotelId = hotelId || goingForwardPropertyIdSelector(state);
    const urlParams = getUrlParams(common, selectedHotelId, mmtId);
    const filterCriteria = getAppliedFiltersInUrl(detailsUnif?.appliedFiltersInUrl || []) || [];
    const unifFilterCriteria = getFilterCriteria({appliedFilters: newFilterData || []}) || [];

    const requestObj = {
      pokus: common?.pokusExpData,
      urlParams,
      selectedCurrency: 'INR',
      requiredFlags: {
        addOnRequired: true,
        applyAbsorption: true,
        bestCoupon: true,
        bestOffersLimit: 3,
        freeCancellationAvail: true,
        responseFilterFlags: true,
        soldOutInfoReq: true,
        walletRequired: true,
        detailPersuasionCardsRequired: true,
      },
      flavour,
      filterCriteria: !!filterCriteria?.length ? filterCriteria : unifFilterCriteria,
    };
    // if (!(isSeo || isDatePickRequired)) {
    //   setUserSearchInformationInLocalStorage(checkin, checkout, roomString);
    // }
    dispatch(updateSearchRoomFetchStatus({status: API_STATE.LOADING_STATE}));
    // const vhid = hoteldId || goingForwardPropertyIdSelector(state);
    fetchSearchRoomData(requestObj, flavour)
      .then(response => {
        if (response?.data?.error) {
          dispatch(
            updateSearchRoomFetchStatus({status: API_STATE.ERROR_STATE(response?.data?.error)}),
          );
        } else {
          dispatch(updateSearchRoomData({data: response?.data?.response || {}}));
          dispatch(updateSearchRoomFetchStatus({status: API_STATE.SUCCESS_STATE}));
        }
        successCallback();
      })
      .catch(err => {
        console.log(err);
        const {status = '', statusText = ''} = err?.response || {};
        dispatch(updateSearchRoomFetchStatus({status: API_STATE.SUCCESS_STATE}));
        dispatch(updateSearchRoomData({data: {}}));
        pushOmnitureErrorThunk({
          dispatch,
          additionalData: {error: `${omnitureConfig.APIType.searchRoom}|${status}|${statusText}`},
        });
      });
  };
};

export const fetchCartUpdatedPriceDataThunk = ({
  flavour = 'desktop',
  requestData,
  cartUIData,
  arcLimitData,
  hotelId = '',
}): ThunkAction<void, AppState, {}, AnyAction> => {
  // Invoke API
  return (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    dispatch(updateDetailsCartFetchStatus({isLoading: true}));
    dispatch(updateDetailsCartRequestData(requestData));

    const state = getState();
    const {common, detailsUnif} = state;
    const selectedHotelId = hotelId || goingForwardPropertyIdSelector(state);
    const urlParams = getUrlParams(
      common,
      selectedHotelId,
      detailsUnif?.searchRooms?.data?.hotelDetails?.hotelId,
    );
    // const urlParams = getUrlParams(common, hotelId);

    const roomArray = Object.keys(detailsUnif?.cartRequestPayload).map(
      (item, index) => detailsUnif?.cartRequestPayload[item],
    );

    // If Room Array is empty then don't hit API
    if (roomArray && roomArray?.length == 0) {
      dispatch(setSelectedRatePlanAction(null));
      dispatch(updateDetailsCartResponseData({}));
      dispatch(updateDetailsCartUIData({}));
      if (arcLimitData) {
        dispatch(updateArcReachedForRoomCode({}));
      }

      dispatch(setActivePayModeInCart(-1));
      dispatch(updateDetailsCartFetchStatus({isLoading: false}));
    } else {
      const getPayMode =
        (cartUIData &&
          Object.keys(cartUIData).length > 0 &&
          cartUIData[Object.keys(cartUIData)[0]]?.roomData?.[
            flavour == 'desktop' ? 'payModeNew' : 'payMode'
          ]) ||
        -1;

      const requestObj = {
        urlParams,
        selectedCurrency: 'INR',
        flavour,
        roomCriteria: roomArray,
        searchType: 'O',
        payMode: getPayMode,
        pokus: common?.pokusExpData,
      };

      fetchCartUpdatePriceData(requestObj, flavour)
        .then(response => {
          if (response?.data?.response?.defaultPriceKey && response?.data?.response?.priceMap) {
            const data = response?.data?.response;

            dispatch(updateDetailsCartResponseData(data)); //This sets API Response after items added in cart

            dispatch(updateDetailsCartUIData(cartUIData)); // This sets data which needs to be used for displaying Cart UI in Cart Row
            dispatch(setActivePayModeInCart(getPayMode)); // This sets Active Pay Mode in Cart so that no different Pay mode is added
            if (arcLimitData) {
              dispatch(updateArcReachedForRoomCode(arcLimitData)); // This sets Arc Limit Reached to check if ARC == Added Room Count
            }
            if (flavour == 'PWA') {
              let selectedRoomInfo = getRoomsArrayForCartRooms({cartUIData});
              dispatch(
                setSelectedRatePlanAction({
                  tariffs: data,
                  selectedRoomInfo: selectedRoomInfo,
                  rootLevelInfo: {
                    searchType: 'O',
                  },
                }),
              );
            }
          }

          dispatch(updateDetailsCartFetchStatus({isLoading: false}));
        })
        .catch(err => {
          console.trace(err);
          dispatch(updateDetailsCartFetchStatus({isLoading: false}));
        });
    }
  };
};

export const fetchAlternateDatesThunk = ({flavour = 'desktop', hotelId = ''} = {}): ThunkAction<
  void,
  AppState,
  {},
  AnyAction
> => {
  return async (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    const state = getState();
    const {common, detailsUnif} = state;
    const selectedHotelId = hotelId || goingForwardPropertyIdSelector(state);
    const urlParams = getUrlParams(
      common,
      selectedHotelId,
      detailsUnif?.searchRooms?.data?.hotelDetails?.hotelId,
    );
    dispatch(updateAlternateDatesFetchStatus({status: API_STATE.LOADING_STATE}));
    dispatch(
      updateAlternateDatesHotelId({
        hotelId: selectedHotelId,
      }),
    );
    const requestObj = {
      pokus: common?.pokusExpData,
      urlParams,
      selectedCurrency: 'INR',
      requiredFlags: {
        addOnRequired: true,
        applyAbsorption: true,
        bestCoupon: true,
        bestOffersLimit: 3,
        freeCancellationAvail: true,
        responseFilterFlags: true,
        soldOutInfoReq: true,
        walletRequired: true,
      },
      flavour,
    };

    fetchAlternateDate(requestObj)
      .then(response => {
        if (
          response?.data?.hotelList &&
          response?.data?.hotelList[selectedHotelId]?.alternateDates
        ) {
          dispatch(
            updateAlternateDatesData({
              data: response?.data?.hotelList[selectedHotelId]?.alternateDates,
              hotelId: selectedHotelId,
            }),
          );
          dispatch(updateAlternateDatesFetchStatus({status: API_STATE.SUCCESS_STATE}));
        } else {
          dispatch(updateAlternateDatesFetchStatus({status: API_STATE.ERR_STATE}));
        }
      })
      .catch(err => {
        console.trace(err);
        dispatch(updateAlternateDatesFetchStatus({status: API_STATE.ERR_STATE}));
      });
  };
};

export const fetchDayUseDetailsSlotsDataThunk = ({
  flavour = 'desktop',
  hotelId = '',
  successCallback = () => {},
}): ThunkAction<void, AppState, {}, AnyAction> => {
  // Invoke API
  return (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    const state = getState();
    const {common} = state;
    const selectedHotelId = hotelId || goingForwardPropertyIdSelector(state);
    const urlParams = getUrlParams(common, selectedHotelId);
    const dayUseDetailsSlotsData = getDayUseDetailsSlotsData({
      common,
      selectedHotelId,
    });
    const requestData = prepareSlotsDayUseRequestData({
      dayUseDetailsSlotsData,
      flavour,
      urlParams,
      pokus: common?.pokusExpData,
    });
    dispatch(updateSlotsFetchStatus({status: API_STATE.LOADING_STATE}));
    fetchSlotsDayUseDetailsData({
      requestData,
      client: flavour,
    })
      .then(response => {
        if (response?.data?.response) {
          dispatch(updateSlotsData({data: response?.data?.response || {}}));
          dispatch(updateSlotsFetchStatus({status: API_STATE.SUCCESS_STATE}));
          successCallback();
        } else {
          dispatch(updateSlotsFetchStatus({status: API_STATE.ERROR_STATE(response?.data?.error)}));
          dispatch(updateSlotsData({data: {}}));
        }
      })
      .catch(err => {
        console.log(err);
        const {status = '', statusText = ''} = err?.response || {};
        dispatch(updateSlotsFetchStatus({status: API_STATE.ERR_STATE}));
        // pushOmnitureErrorThunk({
        //   dispatch,
        //   additionalData: {error: `${omnitureConfig.APIType.searchRoom}|${status}|${statusText}`},
        // });
      });
  };
};
